(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart--main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cartPickup = document.getElementById('cartPickup');
    const cartPickupItems = document.getElementById('cartPickupItems');

    if (cartPickup && cartPickupItems) {
      // Bold location names joined as "A", "A and B", "A, B, and C"
      const listNames = (names, colorClass) =>
        names.flatMap((name, i) => {
          const strong = document.createElement('strong');
          strong.className = colorClass;
          strong.textContent = name;
          if (i === 0) return [strong];
          if (i < names.length - 1) return [', ', strong];
          return [names.length > 2 ? ', and ' : ' and ', strong];
        });

      const items = JSON.parse(cartPickupItems.textContent);

      // Liquid only exposes store_availabilities for a product's selected variant,
      // so each cart variant's availability comes from templates/product.pickup.liquid
      Promise.all(
        items.map((item) =>
          fetch(`/products/${item.handle}?variant=${item.variant}&view=pickup`)
            .then((response) => (response.ok ? response.json() : []))
            .catch(() => [])
        )
      ).then((itemAvailabilities) => {
        // Every location any item can be picked up from, in the order Shopify lists them
        const locations = new Map();
        itemAvailabilities.flat().forEach((location) => locations.set(location.id, location.name));
        if (locations.size === 0) return;

        const available = [];
        const someUnavailable = [];
        const allUnavailable = [];

        // A location is available only when every item in the cart is available there
        locations.forEach((name, id) => {
          const availableCount = itemAvailabilities.filter((list) =>
            list.some((location) => location.id === id && location.available)
          ).length;

          if (availableCount === items.length) available.push(name);
          else if (availableCount > 0) someUnavailable.push(name);
          else allUnavailable.push(name);
        });

        const sentences = [];
        if (available.length) {
          sentences.push(['Your cart is available for pickup at the ', ...listNames(available, 'text-pob-green'), '.']);
        }
        if (someUnavailable.length) {
          sentences.push([
            'Some items are not available for pickup at the ',
            ...listNames(someUnavailable, 'text-red-900'),
            '.',
          ]);
        }
        if (allUnavailable.length) {
          const subject = items.length === 1 ? 'This item is' : 'These items are';
          sentences.push([
            `${subject} not available for pickup at the `,
            ...listNames(allUnavailable, 'text-red-900'),
            '.',
          ]);
        }

        cartPickup.replaceChildren(...sentences.flatMap((sentence, i) => (i === 0 ? sentence : [' ', ...sentence])));
        cartPickup.hidden = false;

        // Each line item lists every cart location; a location missing from its list is unavailable
        document.querySelectorAll('[data-item-pickup]').forEach((list, index) => {
          const itemLocations = itemAvailabilities[index] || [];
          list.replaceChildren(
            ...Array.from(locations, ([id, name]) => {
              const isAvailable = itemLocations.some((location) => location.id === id && location.available);
              const colorClass = isAvailable ? 'text-pob-green' : 'text-red-900';
              const li = document.createElement('li');
              li.className = 'flex items-center gap-1';
              const icon = document.createElement('ion-icon');
              icon.setAttribute('name', isAvailable ? 'checkmark-sharp' : 'ban-sharp');
              icon.setAttribute('aria-hidden', 'true');
              icon.className = colorClass;
              const strong = document.createElement('strong');
              strong.className = colorClass;
              strong.textContent = name;
              li.append(icon, strong, isAvailable ? ': Available' : ': Unavailable');
              return li;
            })
          );
          list.parentElement.hidden = false;
        });
      });
    }

    const cartNoteField = document.getElementById('CartNote');

    if (cartNoteField) {
      // Set initial value from cart
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          cartNoteField.value = cart.note || '';
        });

      // Add debounced event listener for changes
      let timeout;
      cartNoteField.addEventListener('input', function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: e.target.value,
            }),
          })
            .then((response) => response.json())
            .catch((error) => console.error('Error updating cart note:', error));
        }, 500); // Wait 500ms after typing stops before updating
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"]) return;
  try {
    
  class HeroCarousel {
    constructor() {
      this.track = document.getElementById('track');
      this.dots = document.querySelectorAll('.dot');
      this.playPauseBtn = document.getElementById('playPauseBtn');

      this.currentSlide = 0;
      this.totalSlides = 4;
      this.autoplayInterval = this.track.dataset.autoplayInterval || 5000; // Default to 5 seconds
      this.autoplayTimer = null;
      this.isPlaying = true;

      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;

      this.init();
    }

    init() {
      this.addEventListeners();
      this.startAutoplay();
    }

    addEventListeners() {
      // Play/pause button
      this.playPauseBtn.addEventListener('click', () => this.togglePlayPause());

      // Dot indicators
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch events for mobile swipe
      this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
      this.track.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });

      // Mouse events for desktop drag
      this.track.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.track.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.track.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.track.addEventListener('mouseleave', (e) => this.handleMouseUp(e));

      // Pause autoplay on hover
      this.track.addEventListener('mouseenter', () => {
        if (this.isPlaying) this.pauseAutoplay();
      });
      this.track.addEventListener('mouseleave', () => {
        if (this.isPlaying) this.startAutoplay();
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.pauseAutoplay();
    }

    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    }

    handleTouchEnd(e) {
      const threshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      this.startAutoplay();
    }

    handleMouseDown(e) {
      this.isDragging = true;
      this.touchStartX = e.clientX;
      this.track.style.cursor = 'grabbing';
      this.pauseAutoplay();
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.touchEndX = e.clientX;
    }

    handleMouseUp(e) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.track.style.cursor = 'grab';

      const threshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      this.startAutoplay();
    }

    goToSlide(index) {
      this.currentSlide = index;
      this.updateCarousel();
      if (this.isPlaying) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    togglePlayPause() {
      this.isPlaying = !this.isPlaying;
      this.playPauseBtn.textContent = this.isPlaying ? '⏸' : '▶';

      if (this.isPlaying) {
        this.startAutoplay();
      } else {
        this.pauseAutoplay();
      }
    }

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
      this.updateCarousel();
    }

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      this.updateCarousel();
    }

    updateCarousel() {
      const translateX = -this.currentSlide * 100;
      this.track.style.transform = `translateX(${translateX}%)`;

      // Update dots
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentSlide);
      });

    }

    startAutoplay() {
      if (!this.isPlaying) return;
      this.pauseAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

  }

  // Initialize carousel when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new HeroCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
  class HeroCarousel {
    constructor() {
      this.track = document.getElementById('track');
      this.dots = document.querySelectorAll('.dot');
      this.playPauseBtn = document.getElementById('playPauseBtn');

      this.currentSlide = 0;
      this.totalSlides = this.track.dataset.slidesCount;
      this.autoplayInterval = this.track.dataset.autoplayInterval || 5000; // Default to 5 seconds
      this.autoplayTimer = null;
      this.isPlaying = true;

      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;

      this.init();
    }

    init() {
      this.addEventListeners();
      this.startAutoplay();
    }

    addEventListeners() {
      // Play/pause button
      this.playPauseBtn.addEventListener('click', () => this.togglePlayPause());

      // Previous and next buttons
      const prevBtn = document.querySelector('.carousel-prev');
      const nextBtn = document.querySelector('.carousel-next');

      // Add click handlers for prev/next buttons
      prevBtn.addEventListener('click', () => {
        this.prevSlide();
        if (this.isPlaying) {
          this.pauseAutoplay();
          this.startAutoplay();
        }
      });

      nextBtn.addEventListener('click', () => {
        this.nextSlide();
        if (this.isPlaying) {
          this.pauseAutoplay();
          this.startAutoplay();
        }
      });

      // Dot indicators
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch events for mobile swipe
      this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
      this.track.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });

      // Mouse events for desktop drag
      this.track.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.track.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.track.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.track.addEventListener('mouseleave', (e) => this.handleMouseUp(e));

      // Pause autoplay on hover
      this.track.addEventListener('mouseenter', () => {
        if (this.isPlaying) this.pauseAutoplay();
      });
      this.track.addEventListener('mouseleave', () => {
        if (this.isPlaying) this.startAutoplay();
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.pauseAutoplay();
    }

    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    }

    handleTouchEnd(e) {
      const threshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      this.startAutoplay();
    }

    handleMouseDown(e) {
      this.isDragging = true;
      this.touchStartX = e.clientX;
      this.track.style.cursor = 'grabbing';
      this.pauseAutoplay();
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.touchEndX = e.clientX;
    }

    handleMouseUp(e) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.track.style.cursor = 'grab';

      const threshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      this.startAutoplay();
    }

    goToSlide(index) {
      this.currentSlide = index;
      this.updateCarousel();
      if (this.isPlaying) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    togglePlayPause() {
      this.isPlaying = !this.isPlaying;
      this.playPauseBtn.textContent = this.isPlaying ? '⏸' : '▶';

      if (this.isPlaying) {
        this.startAutoplay();
      } else {
        this.pauseAutoplay();
      }
    }

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
      this.updateCarousel();
    }

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      this.updateCarousel();
    }

    updateCarousel() {
      const translateX = -this.currentSlide * 100;
      this.track.style.transform = `translateX(${translateX}%)`;

      // Update dots
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentSlide);
      });
    }

    startAutoplay() {
      if (!this.isPlaying) return;
      this.pauseAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize carousel when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new HeroCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page--adoptions"] && !Shopify.designMode) return;
  try {
    
  const locationFilterButtons = document.querySelectorAll('button.location-filter');

  const updateAdoptionTiles = () => {
    const adoptionTiles = document.querySelectorAll('.adoption-tile.available');
    const activeIds = [...document.querySelectorAll('button.location-filter[data-active="true"]')].map(b => b.dataset.id);
    if (!activeIds.length) {
      adoptionTiles.forEach(tile => {
        tile.classList.remove('hidden');
      });
      return true;
    }

    adoptionTiles.forEach(tile => {
      activeIds.includes(tile.dataset.location) ? tile.classList.remove('hidden') : tile.classList.add('hidden');
    });
  }

  const updateLocationFilter = async (button, id, active = false) => {
    if (!button || !id) {
      console.error('Unable to filter available pets.');
      return false;
    }
    active = active === 'true' ? true : false;
    locationFilterButtons.forEach(button => {
      let locId = button.dataset.id
       locId === id ? button.setAttribute('data-active', !active) : button.setAttribute('data-active', false);
    });
    const adoptionsWrapper = document.getElementById('adoptions-wrapper');
    return true;
  }

  locationFilterButtons.forEach(button => {
    button.addEventListener('click', async () => {
      await updateLocationFilter(button, button.dataset.id, button.dataset.active);
      updateAdoptionTiles();
    });
  });


  } catch(e) { console.error(e); }
})();
})();
